import { connect } from "react-redux";

import { getFeature } from "@template/state/modules/features";

import SecuredTouch from "./SecuredTouch";

const mapStateToProps = state => {
  const securedTouchFeature = getFeature(state, "stc-secured-touch");
  return {
    securedTouchEnabled: !!securedTouchFeature
  };
};

export default connect(mapStateToProps, null)(SecuredTouch);
